import React, {useCallback} from 'react';
import styles from './styles';
import {font_s_md, btn_c_lightRed, colors} from '@xpertdox_js/xdstyle';
import {Animation, Button, IconTextButton, Icons, Form} from '@xpertdox_js/xdcomponents';
import hasValueChanged from '../Hooks/hasValueChanged';
import parentStyles from '../styles';
import InnerEditField from '../InnerEditField';
import { trackActivity } from '../../../../utils/activityTracker'
import { UserContext } from '../../../../Context/UserContext'
import { InstanceContext } from '../../../../InstanceContext'
import {validateValue} from "../../validation";



const DisplayField = props => {

  const {settings, type, hover} = props;
  const [headerHover, setHeaderHover] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [toolTipActive, setToolTipActive] = React.useState(false);
  const hoverRef = React.useRef(null);
  const mounted = React.useRef(true);
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  React.useEffect(() => () => mounted.current = false, [])
  if (headerHover && hoverRef.current === null) {
    hoverRef.current = setTimeout(() => {if (mounted.current) setToolTipActive(true)}, 600);
  } else if (!headerHover && hoverRef.current) {
    clearTimeout(hoverRef.current);
    hoverRef.current = null;
  }

  let propertyStyles = {...styles.property, width: '25%'};
  let valueStyles = {...styles.value, width: '75%'};

  if (headerHover) propertyStyles = {...propertyStyles, background: colors.lightBlue}

  const valueHasChanged = hasValueChanged(props.settings.value, props.valueState);
  let containerStyles = {width: props.width, position: 'relative'}
  if (valueHasChanged) {
    containerStyles = {
      ...containerStyles,
      ...styles.displayContainerChanged,
    }
  }

  let formattedValue = Array.isArray(props.valueState) ? props.valueState.join(', ') : props.valueState === null ? 'N/A' : props.valueState;
  if (settings.formatDisplay) formattedValue = settings.formatDisplay(formattedValue);


  const editFieldAvailable = props.state === 'edit';


  const [formState, setFormState] = React.useState({});
  // default form settings
  const defaults = {
    // label: props.settings.title,
    id: 'editField_' + props.settings.diffProperty,
    labelStyles: {marginBottom: 0, paddingTop: 0, paddingBottom: '6px'},
    styles: {input: {...font_s_md}, textarea: {...font_s_md}},
    value: props.valueState || props.value || props.settings.value,
    attributes: {autoFocus: true},
    notRequired: true,
  }
  const formSettings = [{
    type: 'text',
    id: 'edit_field',
    ...defaults,
  }]
  let propFormSettings = props.settings.formSettings ? [{
    ...defaults,
    ...props.settings.formSettings[0],
    value: defaults.value,
  }] : null;
  // default callback for certain fields to update and switch state to display on selection
  if (!props.customEditField && props.editable !== false && (
  propFormSettings[0].type === 'select'
  || propFormSettings[0].type === 'radio')) {
    propFormSettings[0].callback = value => {
      props.setValueState(value.value);
      props.changeState('display');
    }
  }
  // const hasChanged = hasValueChanged(settings.value, propFormSettings ? formState[propFormSettings[0].id] : props.valueState);
  // const handleSubmit = (value, custom = false) => {
  //   console.log(value, custom)
  //   props.setValueState(custom
  //     ? value
  //     : value && value.value ? value.value : formState['editField_' + props.settings.diffProperty]
  //   );
  //   props.changeState('display');
  // };
  const measureElem = React.useRef();
  React.useLayoutEffect(() => {
    if (measureElem.current && props.height !== measureElem.current.clientHeight && props.state === 'display') {
      props.handleHeight('display', measureElem.current)
    }
  })

  const handleHeightMeasure = useCallback(node => {
    if (node && props.minfieldheight !== node.clientHeight) props.setminfieldheight(node.clientHeight);
  })

  React.useEffect(() => {
    if(['minAge','maxAge'].includes(props.settings.diffProperty)) {
      // console.log(props.valueState, settings)
      let hasError = validateValue(settings.diffProperty, props.valueState, settings.valueToCompare)
      // console.log(hasError, "ERR")
      if(hasError) setShowError(hasError)
      else setShowError(false)
    }
  }, [props.valueState])

  return(
    <div style={containerStyles}>
      <div style={parentStyles.contentInnerWrap} ref={measureElem}>
        <div
          style={propertyStyles}
          onMouseEnter={() => setHeaderHover(true)}
          onMouseLeave={() => {
            setHeaderHover(false);
            setToolTipActive(false);
          }}
        >
          <h4 style={styles.propertyText}>
            {settings.title}
            {headerHover &&
              <Icons
                icon='question'
                style={styles.tooltipIcon}
              />
            }
          </h4>
          {toolTipActive &&
            <div style={styles.toolTipContainer}>
              <p style={styles.toolTipText}>{props.toolTip || 'Put tooltip text here!'}</p>
            </div>
          }
        </div>
        <div style={valueStyles}>
          {/* text display */}
          {type === 'text' && !props.customDisplayField && !editFieldAvailable &&
            <p style={valueHasChanged ?
              {...styles.valueText, ...styles.diffValueNew}
              : styles.valueText
            } ref={handleHeightMeasure}>
              {valueHasChanged ? formattedValue : ((settings.formatDisplay ? settings.formatDisplay(settings.value) : ((Array.isArray(settings.value) && settings.value.length > 0) ? settings.value : (settings.value || null))) || 'N/A')}
            </p>
          }
          {/* custom display field */}
          {props.customDisplayField && !editFieldAvailable && props.customDisplayField()}
          {/* simple component - edit field */}
          {editFieldAvailable &&
            <InnerEditField
              minfieldheight={props.minfieldheight}
              changeState={props.changeState}
              settings={props.settings}
              valueState={props.valueState}
              setValueState={props.setValueState}
              value={props.value}
              customEditField={props.customEditField}
              editable={props.editable}
              height={props.height}
              handleHeight={props.handleHeight}
              state={props.state}
              isSimpleComponent={props.isSimpleComponent}
            />
          }
          {showError && <div style={styles.errorMsg}>{showError}</div>}
          {valueHasChanged && !editFieldAvailable &&
            <IconTextButton
              onClick={() => {
                props.setValueState(settings.value, true);
                if (props.clearCallback) props.clearCallback();
                handleActivityLogUpdate(`DisplayField.handleActivityLogUpdate`)
              }}
              styles={{borderRadius: '10rem', marginTop: '.4rem'}}
              preBuiltStyles={btn_c_lightRed}
              icon='x'
              text='Clear Changes'
              size='sm'
            />
          }
        </div>
      </div>
    </div>
  )
}

export default DisplayField;
